import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import "./PassengerDetail.css";
import { bookSeats } from "../../../Redux/userReducer";
import { useLocation } from "react-router-dom";
import { Select } from "@windmill/react-ui";
import Cookies from "universal-cookie";
/* import Select from "react-select"; */
import PhoneInput from "react-phone-input-2";
import countryList from "react-select-country-list";
import moment from "moment";
import { CountryDropdown } from 'react-country-region-selector';

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import language from "../../../language";
import "react-phone-input-2/lib/style.css"; // import the styles

import Swal from "sweetalert2";
import { DatePicker, SelectPicker } from "rsuite";
import { bookSeatsWithoutLogin } from "../../../Redux/userReducer";
import { useDispatch } from "react-redux";
//mui
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import TextField from "@mui/material/TextField";

import { bookingIdStore } from "../../../Redux/userReducer";

import { useHistory } from "react-router-dom";
//icons
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useSelector } from "react-redux";
import { UpdatePassengerDetail } from "../../../actions/bookings";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const PassengerDetail = (props) => {
  const cookies = new Cookies();

  const isLogin = cookies.get("auth");

  const dispatch = useDispatch();

  const receivedData = props.location.state;
  let query = useQuery();
  let tripId = query.get("tripId");
  console.log(receivedData, "receivedData")
  const history = useHistory();
  const [phone, setPhone] = useState("");
  const [nationalities, setNationalities] = useState([]);
  const [valid, setValid] = useState();
  const [emailChecker, setEmailChecker] = useState();
  const [selectedNationality, setSelectedNationality] = useState("");
  const [tempDOB, setTempDOB] = useState();
  const totalPassenger = useSelector((state) => state?.buses?.requesInfo?.totalPassenger);
  const reduxPassengerDetail = useSelector((state) => state?.bookings?.bookingInfo?.passengerDetail);
  const [passengerDetail, setPassengerDetail] = useState(() => {
    return reduxPassengerDetail && Object.keys(reduxPassengerDetail).length > 0
      ? reduxPassengerDetail
      : {
        cCode: "971",
        phone: "",
        email: "",
        passengers: [
          {
            firstName: "",
            middleName: "",
            lastName: "",
            gender: "",
            dob: null,
            passportNumber: "",
            country: "",
            image: null,
          },
        ],
      };
  });
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
      !sessionStorage.getItem("language")
      ? true
      : false;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPassengerDetail({ ...passengerDetail, [name]: value });

    if (emailRegex.test(passengerDetail.email)) {
      setEmailChecker(2);
    }
  };
  const handleBookingData = (e, index) => {
    const { name, value } = e.target;

    // If the field belongs to a passenger, update that passenger's details
    if (
      name === "firstName" ||
      name === "middleName" ||
      name === "lastName" ||
      name === "gender" ||
      name === "passportNumber" ||
      name === "country"
    ) {
      const updatedPassengers = [...passengerDetail.passengers];
      updatedPassengers[index] = {
        ...updatedPassengers[index],
        [name]: value,
      };

      setPassengerDetail({
        ...passengerDetail,
        passengers: updatedPassengers,
      });
    } else if (name === "dob") {
      // If the field is date of birth, handle it differently
      const updatedPassengers = [...passengerDetail.passengers];
      updatedPassengers[index] = {
        ...updatedPassengers[index],
        dob: value, // assuming the DatePicker component directly passes the date string
      };

      setPassengerDetail({
        ...passengerDetail,
        passengers: updatedPassengers,
      });
    } else if (name === "image") {
      const updatedPassengers = [...passengerDetail.passengers];
      updatedPassengers[index] = {
        ...updatedPassengers[index],
        image: e.target.value,
      };

      setPassengerDetail({
        ...passengerDetail,
        passengers: updatedPassengers,
      });
    } else {
      setPassengerDetail({
        ...passengerDetail,
        [name]: value,
      });
    }
  };
  const handleChange1 = (value, name) => {
    setPassengerDetail({ ...passengerDetail, cCode: value.trim() });
  };


  console.log(passengerDetail, "passengerDetail")

  const [startDate, setStartDate] = useState(new Date());
  const [value, setValue] = useState("");
  const [imagePassport, setImagePassport] = useState();
  const options = useMemo(() => countryList().getData(), []);



  const [gender, setGender] = useState();
  const [date, setDateOfBirth] = useState();
  const [country, setCountry] = useState();

  const genderHandleChange = (e) => {
    setGender(e.target.value);
  };
  const dateHandleChange = (newDate) => {
    setPassengerDetail({ ...passengerDetail, dateOfBirth: newDate });
    // setDateOfBirth(value);
  };

  const changeHandler = (value) => {
    setValue(value);
  };

  const countryHandleChange = (value) => {
    setCountry(value);
  };

  const handleImageChange1 = (e) => {
    // const selected = e.target.files[0];
    const selected = e.target.files[0];

    setImagePassport(selected);
  };


  const data = ["Male", "Female"]?.map((item) => ({ label: item, value: item }));

  const breadcrumbs = [
    <p>BusListing</p>,
    <p>Seat Selection</p>,
    <p>Passenger Detail</p>,
  ];


  let checkVariable = Array.isArray(receivedData?.seats);




  const proceedPaymentClicked = async () => {
    const { cCode, phone, email, passengers } = passengerDetail;

    // Validation: Check total passengers
    if (passengers.length !== totalPassenger) {
      Swal.fire({
        icon: "error",
        title: "Incomplete Details",
        text: `Please fill in details for all ${totalPassenger} passengers.`,
      });
      return; // Stop execution if validation fails
    }

    // Validation: Check if all fields are filled for passengers
    const isPassengerValid = passengers.every((passenger) => {
      return (
        passenger.firstName &&
        passenger.lastName &&
        passenger.gender &&
        passenger.dob &&
        passenger.passportNumber &&
        passenger.country &&
        passenger.image
      );
    });

    // Validation: Check cCode, phone, and email
    if (!cCode || !phone || !email || !isPassengerValid) {
      Swal.fire({
        icon: "error",
        title: "Incomplete Details",
        text: "Please fill in all required fields.",
      });
      return; // Stop execution if validation fails
    }

    // If all validations pass, update Redux and navigate
    await dispatch(UpdatePassengerDetail(passengerDetail));
    history.push("/client/checkout");
  };


  const handleBlur = () => {
    // setTimeout(() => {
    //   toRef1.current.focus();
    // }, 0);
  };

  function handleSelect(event) {
    // setSelectedNationality(event.target.value);
    setPassengerDetail({
      ...passengerDetail,
      selectCountry: event.target.value,
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    // add code to save the selected nationality
  }



  return (
    <>
      <div className="passengerWrapperTop passengerWrapperTopH3">
        <Grid container className="CheckoutWrapper passengerWrapper">
          <Grid
            item
            xs={12}
            className="CheckoutContainer"
            display="flex"
            justifyContent="center"
          >
            <Grid item xs={12} xl={12} className="bgGrey topInneCardPassDet">
              <Grid container>
                <Grid item xl={9} lg={9} md={12} sm={12} xs={12}>
                  <Grid item className="title">
                    <p className="PassegText">
                      {languageSelectedEnglish
                        ? "Passenger Detail"
                        : language.passengerDetail}
                    </p>
                  </Grid>

                  {/* Breadcrumbs */}
                  <Grid
                    item
                    xs={12}
                  >
                    <Breadcrumbs
                      separator={<NavigateNextIcon fontSize="small" />}
                      aria-label="breadcrumb"
                    >
                      {breadcrumbs}
                    </Breadcrumbs>
                  </Grid>

                  {Array(totalPassenger)
                    .fill(true)
                    ?.map((item, index) => {
                      return (
                        <Accordion
                          key={index}
                          className="accordian"
                          expanded={true}
                        >
                          <AccordionSummary
                            // expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Grid
                              item
                              xs={12}
                              className="heading inputMargins"
                              sx={{
                                margin: "40px 0",
                                fontSize: "2rem",
                                color: "#0c2f54",
                              }}
                            >
                              <p className="passInfoTxt">
                                {languageSelectedEnglish
                                  ? "Passenger"
                                  : language.passenger}
                                {index + 1}{" "}
                                {languageSelectedEnglish
                                  ? "Information"
                                  : language.information}
                              </p>
                            </Grid>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Grid
                              xs={12}
                              container
                              justifyContent="space-between"
                              className="twoInputs"
                            >
                              <Grid
                                item
                                xs={12}
                                xl={3.9}
                                md={3.9}
                                lg={3.9}
                                sx={{ margin: "10px 0" }}
                              >
                                <TextField
                                  id="outlined-basic"
                                  type="text"
                                  label={
                                    languageSelectedEnglish
                                      ? "First Name"
                                      : language.firstName
                                  }
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={passengerDetail?.passengers[index]?.firstName || ''}
                                  name="firstName"
                                  onChange={(e) => handleBookingData(e, index)}
                                  variant="outlined"
                                  style={{
                                    margin: "auto",
                                    border:
                                      valid === 1 && !passengerDetail.firstName
                                        ? "1px solid red"
                                        : "",
                                  }}
                                  className="textFieldPassDet"
                                />
                                {valid === 1 && !passengerDetail.firstName && (
                                  <div style={{ color: "red" }}>Required</div>
                                )}
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                xl={3.9}
                                md={3.9}
                                lg={3.9}
                                sx={{ margin: "10px 0" }}
                              >
                                <TextField
                                  id="outlined-basic"
                                  type="text"
                                  label={
                                    languageSelectedEnglish
                                      ? "Middle Name"
                                      : language.middleName
                                  }
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={passengerDetail?.passengers[index]?.middleName || ''}
                                  name="middleName"
                                  onChange={(e) => handleBookingData(e, index)}
                                  variant="outlined"
                                  style={{ margin: "auto" }}
                                  className="textFieldPassDet"
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                xl={3.9}
                                lg={3.9}
                                md={3.9}
                                sx={{ margin: "10px 0" }}
                              >
                                <TextField
                                  id="outlined-basic"
                                  fullWidth
                                  type="text"
                                  // value={passengerDetail.lastName}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={passengerDetail?.passengers[index]?.lastName || ''}
                                  name="lastName"
                                  onChange={(e) => handleBookingData(e, index)}
                                  label={
                                    languageSelectedEnglish
                                      ? "Last Name"
                                      : language.lastName
                                  }
                                  variant="outlined"
                                  className="textFieldPassDet"
                                  style={{
                                    margin: "auto",
                                    border:
                                      valid === 1 && !passengerDetail.lastName
                                        ? "1px solid red"
                                        : "",
                                  }}
                                />
                                {valid === 1 &&
                                  !passengerDetail.passengers[index]
                                    .lastName && (
                                    <div style={{ color: "red" }}>Required</div>
                                  )}
                              </Grid>

                            </Grid>
                            <Grid
                              item
                              xs={12}
                              xl={12}
                              lg={12}
                              md={12}
                              sx={{ margin: "10px 0" }}
                            >
                              <TextField
                                id="outlined-basic"
                                fullWidth
                                type="text"
                                value={passengerDetail.email}
                                name="email"
                                onChange={(e) =>
                                  setPassengerDetail({
                                    ...passengerDetail,
                                    email: e.target.value,
                                  })
                                }
                                label={
                                  languageSelectedEnglish
                                    ? "Enter Email"
                                    : language.enterEmail
                                }
                                variant="outlined"
                                className="textFieldPassDet"
                                style={{
                                  margin: "auto",
                                  border:
                                    valid === 1 && !passengerDetail.email
                                      ? "1px solid red"
                                      : "",
                                }}
                                InputLabelProps={{
                                  shrink: passengerDetail.email !== "", // Ensures the label goes to the border when there's an email
                                }}
                              />
                              {valid === 1 && !passengerDetail.email && (
                                <div style={{ color: "red" }}>Required</div>
                              )}
                              {emailChecker === 1 && (
                                <div style={{ color: "red" }}>
                                  Enter Valid Email
                                </div>
                              )}
                            </Grid>
                            <Grid
                              container
                              justifyContent="space-between"
                              className="twoInputs"
                            >
                              <Grid
                                item
                                xs={12}
                                lg={6}
                                md={6}
                                xl={6}
                                sx={{ margin: "10px 0" }}
                              >
                                <Select
                                  className="dataePickerInputPasse genderSelectpassPage"
                                  name="gender"
                                  placeholder="Gender"
                                  onChange={(e) => handleBookingData(e, index)}
                                  value={passengerDetail?.passengers[index]?.gender || ''}
                                >
                                  <option value="" defaultValue hidden>
                                    {languageSelectedEnglish
                                      ? "Gender"
                                      : language.gender}
                                  </option>

                                  <option value="Male">
                                    {languageSelectedEnglish
                                      ? "Male"
                                      : language.male}
                                  </option>
                                  <option value="Female">
                                    {" "}
                                    {languageSelectedEnglish
                                      ? "Female"
                                      : language.female}
                                  </option>
                                </Select>

                                {valid === 1 &&
                                  !!passengerDetail.passengers[index]
                                    .gender && (
                                    <div style={{ color: "red" }}>Required</div>
                                  )}
                              </Grid>
                              <Grid
                                item
                                align="end"
                                sx={{ margin: "10px 0" }}
                                md={6}
                                lg={6}
                                xs={12}
                                xl={6}
                              >
                                <DatePicker
                                  placeholder="Date of birth"
                                  className="dateOfbirth"
                                  maxDate={new Date()}
                                  /*  onChange={setDateOfBirth} */
                                  /*     name="dob" */

                                  onChange={(date) =>
                                    handleBookingData(
                                      { target: { name: "dob", value: date } },
                                      index
                                    )
                                  }
                                  value={
                                    passengerDetail.passengers[index]
                                      ? passengerDetail.passengers[index].dob
                                      : null
                                  }
                                />
                                {valid === 1 &&
                                  !!passengerDetail.passengers[index].dob && (
                                    <div style={{ color: "red" }}>Required</div>
                                  )}
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              justifyContent="space-between"
                              className="twoInputs"
                            >
                              <div
                                style={{ margin: "10px 0" }}
                                className="lowerpassportInput"
                              >
                                <TextField
                                  id="outlined-basic"
                                  type="number"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={passengerDetail?.passengers[index]?.passportNumber || ''}
                                  name="passportNumber"
                                  onChange={(e) => handleBookingData(e, index)}
                                  fullWidth
                                  label={
                                    languageSelectedEnglish
                                      ? "Passport Number / IQAMA Number"
                                      : language.passportNumber
                                  }
                                  variant="outlined"
                                  style={{
                                    margin: "auto",
                                    border:
                                      valid === 1 &&
                                        !passengerDetail.passportNumber
                                        ? "1px solid red"
                                        : "",
                                  }}
                                  className="textFieldPassDet"
                                />

                                {valid === 1 &&
                                  !!passengerDetail.passengers[index]
                                    .passportNumber && (
                                    <div style={{ color: "red" }}>Required</div>
                                  )}
                              </div>
                              <div
                                style={{ margin: "10px 0" }}
                                className="lowerpassportInput"
                              >
                                <CountryDropdown
                                  id="nationality"
                                  name="country"
                                  value={passengerDetail?.passengers[index]?.country || ''}
                                  onChange={(val) =>
                                    handleBookingData({ target: { name: 'country', value: val } }, index)
                                  }
                                  className="selectNationality "
                                  style={{
                                    border: valid === 1 && !passengerDetail.passportNumber ? '1px solid red' : ''
                                  }}
                                  defaultOptionLabel={
                                    languageSelectedEnglish ? '--Select Nationality--' : language.selectNationality
                                  }
                                />
                                {valid === 1 && !!passengerDetail.passengers[index].country && (
                                  <div style={{ color: 'red' }}>Required</div>
                                )}
                              </div>
                            </Grid>
                            <Grid
                              container
                              className="twoInputs "
                            >
                              <div className="mobilenumberOuter">
                                <div
                                >
                                  <PhoneInput
                                    country={"ae"}
                                    enableSearch={true}
                                    value={phone}
                                    onBlur={handleBlur}
                                    // error={error}
                                    onChange={(phone) => {
                                      console.log("Phone number:", phone);
                                      handleChange1(phone, "cCode")
                                    }}
                                  />
                                </div>
                                <div
                                  className="mobileNoInput"
                                >
                                  <TextField
                                    id="outlined-basic"
                                    value={passengerDetail.phone}
                                    name="phone"
                                    onChange={(e) => handleBookingData(e, index)}
                                    type="number"
                                    fullWidth
                                    label={
                                      languageSelectedEnglish
                                        ? "Mobile Number"
                                        : language.mobileNumber
                                    }
                                    variant="outlined"
                                    className="textFieldPassDet noButtons"
                                    style={{
                                      border:
                                        valid === 1 && !passengerDetail.phone
                                          ? "1px solid red"
                                          : "",
                                    }}
                                  />
                                  {valid === 1 && !passengerDetail.phone && (
                                    <div style={{ color: "red" }}>Required</div>
                                  )}
                                </div>
                              </div>


                              <Grid
                                item
                                xs={12}
                                xl={6}
                                md={6}
                                lg={6}
                                sx={{ margin: "10px 0" }}
                                alignSelf="center"
                              >
                                <div
                                  className="upload-div"
                                >
                                  <p className="title-upload">
                                    {languageSelectedEnglish
                                      ? "Upload copy of the Passport/IQAMA"
                                      : language.uploadCopyOfThePassport}
                                  </p>
                                  <input
                                    id="file-uploader"
                                    style={{ display: "block" }}
                                    type="file"
                                    accept="image/*"
                                    name="image"
                                    className="passportUploadewr"
                                    onChange={(e) =>
                                      handleBookingData(
                                        {
                                          target: {
                                            name: "image",
                                            value: e.target.files[0],
                                          },
                                        },
                                        index
                                      )
                                    }
                                  />
                                  {/* {passengerDetail?.passengers[index]?.image && (
                                    <div style={{ marginTop: "8px", fontSize: "14px", color: "#333" }}>
                                      Selected file: {passengerDetail.passengers[index].image.name}
                                    </div>
                                  )} */}
                                </div>
                                {valid === 1 &&
                                  !passengerDetail.passengers[index].image && (
                                    <div style={{ color: "red" }}>Required</div>
                                  )}
                              </Grid>
                            </Grid>

                          </AccordionDetails>
                        </Accordion>
                      );
                    })}
                  <div className="btnTopPayment">
                    {/* <Link to="/client/checkout"> */}
                    <button
                      className="btnPaymentPassDet"
                      onClick={proceedPaymentClicked}
                    >
                      {languageSelectedEnglish
                        ? "Submit and Proceed"
                        : language.submitAndProceed}
                    </button>
                    {/* </Link> */}
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default PassengerDetail;
